import { Container } from "@mantine/core"
import { UseQueryResult } from "@tanstack/react-query"
import { AxiosError } from "axios"
import _ from "lodash"
import { useTranslation } from "react-i18next"

import { ErrorBox } from "../../molecules/ErrorBox/ErrorBox.tsx"
import { InfoBox } from "../../molecules/InfoBox/InfoBox.tsx"
import { Loader } from "../../molecules/Loader/Loader.tsx"

type Props<TData, TError> = {
  query: UseQueryResult<TData, TError>
  children: (props: {
    data: TData
    isFetching: boolean
    isLoading: boolean
    refetch: () => void
  }) => JSX.Element
  acceptEmpty?: boolean
  showLoader?: boolean
}

export const DataFetchWrapper = <TData, TError>({
  query,
  children,
  acceptEmpty,
  showLoader = true,
}: Props<TData, TError>) => {
  const { t } = useTranslation()
  const { data, isLoading, isError, error } = query

  if (isError) {
    return (
      <Container mt="5%" w="100%" h="100%">
        <ErrorBox
          title={t("dataLoad.error.title")}
          error={error as AxiosError}
        />
      </Container>
    )
  }
  if (isLoading) return showLoader ? <Loader fullPage /> : null
  if (!acceptEmpty && (!data || _.isEmpty(data))) {
    return (
      <Container mt="5%" w="100%" h="100%">
        <InfoBox
          title={t("dataLoad.noResults.title")}
          message={t("dataLoad.noResults.message")}
        />
      </Container>
    )
  }
  return children(query)
}
